export const VARIANTS_ICONS = {
  "success": "✔",
  "error": "✘"
}